import React, { useState } from 'react';
import { InstagramSettings as InstagramSettingsType, InstagramSettingsProps } from '../types';

export const InstagramSettings: React.FC<InstagramSettingsProps> = ({ settings, onUpdate }) => {
  const [formData, setFormData] = useState<InstagramSettingsType>(settings);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'number' ? Number(value) : value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    try {
      onUpdate(formData);
      alert('Instagram settings updated successfully!');
    } catch (error) {
      console.error('Error updating Instagram settings:', error);
      alert('Failed to update Instagram settings. Please try again.');
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">Instagram Settings</h1>
      <form onSubmit={handleSubmit} className="max-w-2xl">
        <div className="bg-white rounded-lg shadow p-6 space-y-6">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="autoReply"
              name="autoReply"
              checked={formData.autoReply}
              onChange={handleInputChange}
              className="h-4 w-4 text-blue-600 rounded border-gray-300"
            />
            <label htmlFor="autoReply" className="ml-2 text-sm text-gray-700">
              Enable Auto Reply
            </label>
          </div>

          <div>
            <label htmlFor="replyDelay" className="block text-sm font-medium text-gray-700 mb-1">
              Reply Delay (minutes)
            </label>
            <input
              type="number"
              id="replyDelay"
              name="replyDelay"
              value={formData.replyDelay}
              onChange={handleInputChange}
              min="0"
              className="w-full px-3 py-2 border rounded"
            />
          </div>

          <div>
            <label htmlFor="maxRepliesPerDay" className="block text-sm font-medium text-gray-700 mb-1">
              Maximum Replies Per Day
            </label>
            <input
              type="number"
              id="maxRepliesPerDay"
              name="maxRepliesPerDay"
              value={formData.maxRepliesPerDay}
              onChange={handleInputChange}
              min="0"
              className="w-full px-3 py-2 border rounded"
            />
          </div>

          <button
            type="submit"
            className="w-full px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
}; 